<script lang="ts">
    import { onDestroy } from "svelte";

    import PageIndex from "../../../leafElement/PageIndex.svelte";
    import Spinner from "../../../leafElement/Spinner.svelte";
    import { pushOrderExport } from "../../../script/din/dataBroker";
    import { MES_KEY_STAGE } from "../../../script/enum";
    import type {
        ExportedDataFull,
        MesurmentFull,
    } from "../../../script/types";

    interface ExportedData {
        loaded: boolean;
        loadFail: boolean;
        runExport: () => void;
        export: ExportedDataFull;
    }

    export let selectedMesurment: MesurmentFull[];
    export let resetChecks: () => void;

    let waitingToBeExported: ExportedData[] = [];
    let curentlyExporting = 0;
    let exportedCount = 0;
    $: if (waitingToBeExported.length === 0) exportedCount = 0;

    let selectedCount: number;
    $: selectedCount = selectedMesurment.reduce(
        (acc, val) => acc + (isRedyToExport(val) ? 1 : 0),
        0
    );
    let wrongSelectedCount: number;
    $: wrongSelectedCount = selectedMesurment.length - selectedCount;

    let curentExport: ExportedData;
    $: curentExport =
        waitingToBeExported.length !== 0 &&
        curentlyExporting >= 0 &&
        curentlyExporting < waitingToBeExported.length
            ? waitingToBeExported[curentlyExporting]
            : null;
    let isCurentExportLoadedCorectly = false;
    $: isCurentExportLoadedCorectly =
        curentExport && curentExport.loaded && !curentExport.loadFail;
    $: if (isCurentExportLoadedCorectly) {
        updateRemainingInterval();
    }
    $: if (curentExport && !curentExport.loaded && !curentExport.loadFail) {
        curentExport.runExport();
    }
    let remainingTime = 0;
    const timerUpdateSub = setInterval(updateRemainingInterval, 500);
    function updateRemainingInterval() {
        if (isCurentExportLoadedCorectly) {
            const fullTime =
                curentExport.export.data.validTs - new Date().getTime();
            remainingTime = fullTime > 0 ? Math.floor(fullTime / 1000) : 0;
            // TODO STOP TIMER
        } else {
            remainingTime = 0;
        }
        /*         remainingTime = isCurentExportLoadedCorectly
            ? Math.floor(
                  (curentExport.export.data.validTs - new Date().getTime()) /
                      1000
              )
            : 0; */
    }

    /* async function exportByQr() {
        const exportResponce = await Promise.all(
            selectedMesurment.map((mes) => pushOrderExport(mes))
        );
        console.log(exportResponce)
        waitingToBeExported = exportResponce || null;
    } */
    function isRedyToExport(mes: MesurmentFull) {
        return (
            mes.dinamic.stage.key === MES_KEY_STAGE.fin ||
            mes.dinamic.stage.key === MES_KEY_STAGE.exp
        );
    }
    function exportByQr() {
        waitingToBeExported = selectedMesurment
            .filter(isRedyToExport)
            .map((mes) => {
                const ret = {
                    loaded: false,
                    loadFail: false,
                    runExport: async () => {
                        ret.export = null;
                        ret.loadFail = false;
                        ret.loaded = false;
                        curentExport = curentExport;
                        const result = await pushOrderExport(mes);
                        ret.loaded = true;
                        if (result) {
                            ret.export = result;
                        } else {
                            ret.loadFail = true;
                        }
                        curentExport = curentExport;
                        exportedCount++;
                        /* exportedCount = waitingToBeExported.reduce(
                        (acc, val) => acc + (val.loaded ? 1 : 0),
                        0
                    ); */
                    },
                    export: null,
                };
                return ret;
            });
    }

    function refreshToken() {}

    function exitExport() {
        resetChecks();
        waitingToBeExported = [];
        curentlyExporting = 0;
    }
    function copyId(text) {
        navigator.clipboard.writeText(text);
    }

    function cleanUp() {
        clearInterval(timerUpdateSub);
    }
    onDestroy(cleanUp);
</script>

{#if waitingToBeExported.length === 0}
    <div class="standartButton_SMargin borderBox simpleBox">
        <span class="simpleTitle simpleTitleShifted">Vybráno k exportu:</span>
        <div class="simpleBoxInter">
            <span class="simpleText" style="margin-bottom: 2px;"
                >{selectedCount}</span
            >
            <button
                disabled={selectedCount === 0}
                class="standartButton standartButton_SMargin"
                on:click={exportByQr}>Exportovat</button
            >
        </div>
        {#if wrongSelectedCount !== 0}
            <p class="smallWarning">
                Vybráno neexportovatelné: {wrongSelectedCount}
            </p>
        {/if}
    </div>
{:else}
    {#if curentExport && curentExport.loaded}
        <div class="qrCodeWrap borderBox">
            <h2 class="qrCodeText">
                Token pro: {curentExport.export.mes.static.id}
                <span style="margin-left: 1.3em;">
                    {remainingTime < 90
                        ? `${remainingTime} (s)`
                        : `${Math.round(remainingTime / 60)} (min)`}
                </span>
            </h2>
            <div class="qrCodeToken">
                <h2>{curentExport.export.data.token}</h2>
                <!-- inactiveIconPlus customIcon -->
                <div
                    class="activeIcon"
                    class:activeIconDisabled={!curentExport.export.data.token}
                    on:click={() => copyId(curentExport.export.data.token)}
                >
                    <span class="material-icons" style="font-size: 1.6rem;">
                        content_copy
                    </span>
                </div>
            </div>
            <img src={curentExport.export.data.qr} />
            {#if remainingTime < 2}
                <div class="owerlay" />
                <div class="centerWarn">
                    <div class="standartFilledMesage warningColors">
                        <span class="material-icons"> warning_amber </span>
                        <span>Expirováno</span>
                    </div>
                    <!-- <button class="standartButton" on:click={refreshToken}
                    >Znovu požádat o token</button
                > -->
                </div>
            {/if}
        </div>
    {:else}
        <div class="qrCodeWrap borderBox">
            <p style="margin-right: 1rem;">Načítání</p>
            <Spinner />
        </div>
    {/if}
    <div class="pageControl">
        <PageIndex
            bind:index={curentlyExporting}
            max={waitingToBeExported.length - 1}
        />
        {#if exportedCount == waitingToBeExported.length}
            <button
                class="standartButton standartButton_SMargin"
                on:click={exitExport}>Uzavřít Export</button
            >
        {:else}
            <button
                class="standartButton standartButton_SMargin"
                on:click={exitExport}
                >Odejít, zbývá {waitingToBeExported.length -
                    exportedCount}</button
            >
        {/if}
    </div>
{/if}

<style>
    .owerlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.6;
        background: #aaa;
    }
    .centerWarn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 10;
        position: relative;
        top: -10px;
    }
    .smallWarning {
        font-size: 0.8rem;
        font-weight: 300;
        color: var(--back_D2);
    }

    .pageControl {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 1.5rem 1rem 0 0;
    }
    .simpleTitle {
        font-size: 0.9rem;
        color: var(--back_D2);
        font-weight: 300;
        margin-bottom: 8px;
    }
    .simpleTitleShifted {
        align-self: flex-start;
        margin-left: 1.2rem;
    }
    .simpleBox {
        width: fit-content;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 8px 1rem 0.5rem 1rem;
        margin: 0.5rem;
    }

    .simpleBoxInter {
        display: flex;
        align-items: center;
    }
    .simpleText {
        font-size: 1.9rem;
        margin-right: 0.5em;
        font-weight: 700;
        color: var(--back_D2);
    }

    .qrCodeWrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 1rem auto 0 auto;
        width: fit-content;
        padding: 1rem 2rem;
        position: relative;
    }
    .qrCodeWrap > img {
        width: 100%;
        max-width: 20rem;
    }
    .qrCodeWrap > .qrCodeText {
        font-size: 0.9rem;
        font-weight: 300;
        color: var(--back_D2);
    }
    .qrCodeToken {
        font-size: 1.3rem;
        font-weight: 300;
        /* color: var(--back_D2); */
        display: flex;
        align-items: center;
    }
    .qrCodeToken > h2 {
        margin: 0;
    }
    .qrCodeToken > .activeIcon {
        margin-left: 20px;
    }
</style>
